import type { FC } from 'react';

import LazyImage from '@crehana/ui/dist/LazyImage';
import { primaryLighter, primaryMain } from '@crehana/ui/dist/styles/colors';
import { useUITheme } from '@crehana/web/Layouts/UITheme';
import { clsx } from 'clsx';

import type { StepContentProps } from './types';

const StepContent: FC<React.PropsWithChildren<StepContentProps>> = ({
  image,
  Icon,
  title,
  description,
}) => {
  const { isDark } = useUITheme();

  return (
    <div>
      {image && (
        <LazyImage
          className="w-full rounded-t-5 block h-280"
          imgClassName="rounded-t-5"
          alt={title}
          src={image}
        />
      )}
      <div className="px-24 pt-32">
        <div className="flex items-center mb-12">
          {Icon && (
            <Icon
              className="mr-8"
              color={isDark ? primaryLighter : primaryMain}
              size={24}
            />
          )}
          <span className={clsx('font-subtitle2', { 'text-white': isDark })}>
            {title}
          </span>
        </div>
        <p className={clsx('font-body4', { 'text-white': isDark })}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default StepContent;
